module.exports = __webpack_public_path__ + "static/media/pcc_sign_in_button_base_state.cdea8750.svg";